<app-modal
  [title]="'Select items for this payment' | trans:'cart/pay-separately-selection-modal/title.Text'"
  maxWidth="1200px"
  width="100%"
>
  <ng-template>
    @if (cartStore.cart()?.items.length) {
      <div class="d-flex align-items-center gap-8 m-b-16">
        <app-chip
          [value]="!areAllItemsSelected ? 'select-all' : 'select-none'"
          [disabled]="false"
          [selected]="areAllItemsSelected"
          [label]="!areAllItemsSelected ? ('Select all' | trans:'cart/summary-modal/select-all.Label') : ('Select none' | trans:'cart/summary-modal/select-none.Label')"
          (onClick)="toggleAll()"
        />
      </div>
    }

    @if (!cartStore.cart() || cartStore.cart().items.length === 0) {
      <p>{{ 'Cart is empty.'| trans:'cart/summary-modal/empty.Text' }}</p>
    } @else {
      @if (cartStore.groupedCartItemsTickets().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-16">
            @for (item of cartStore.groupedCartItemsTickets(); track item.showId + '_' + item.showBegin + '_' + item.auditoriumName + '_' + item.cinemaName) {
              <ng-container [ngTemplateOutlet]="cartItemTicket" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }

      @if (cartStore.cartItemsProductsAndPackages().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-8">
            @for (item of cartStore.cartItemsProductsAndPackages(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemProduct" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }

      @if (cartStore.cartItemsVouchers().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-8">
            @for (item of cartStore.cartItemsVouchers(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemVoucher" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }

      @if (cartStore.cartItemsCashedVouchers().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-8">
            @for (item of cartStore.cartItemsCashedVouchers(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemVoucher" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }

      @if (cartStore.cartItemsCancelledTickets().length > 0 || cartStore.cartItemsCancelledGoods().length > 0 || cartStore.cartItemsCancelledVouchers().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-8">
            @for (item of cartStore.cartItemsCancelledTickets(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemSimple" [ngTemplateOutletContext]="{ item }" />
            }
            @for (item of cartStore.cartItemsCancelledGoods(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemSimple" [ngTemplateOutletContext]="{ item }" />
            }
            @for (item of cartStore.cartItemsCancelledVouchers(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemSimple" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }

      @if (cartStore.cartItemsCards().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-8">
            @for (item of cartStore.cartItemsCards(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemSimple" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }

      @if (cartStore.cartItemsCardPayments().length > 0) {
        <div class="group">
          <div class="d-flex flex-direction-column gap-8">
            @for (item of cartStore.cartItemsCardPayments(); track item.itemId + '_' + item.position) {
              <ng-container [ngTemplateOutlet]="cartItemSimple" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }
    }
  </ng-template>

  <!-- MODAL ACTION BUTTONS -->

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="cancel()"
        type="button"
      >
        {{ 'Cancel'| trans:'cart/price-category-picker-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        type="button"
        [disabled]="!hasSelection() || confirmInProgress"
        (click)="confirm()"
      >
        {{ 'Confirm'| trans:'cart/price-category-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<ng-template #cartItemTicket let-item="item">
  <div class="d-flex flex-direction-column gap-8">
    <div class="d-flex align-items-center gap-16 p2">
      <span class="fw-semibold">{{ item.showTitle }}</span>
      <span>{{ item.showBegin | localeDatetimeFormat }}</span>

      @if (cartStore.showTicketCinemaName()) {
        <span>{{ item.cinemaName }}</span>
      }

      <span>{{ item.auditoriumName }}</span>
    </div>
    @for (ticket of item.tickets; track ticket.itemId + '_' + ticket.position) {
      <div
        class="p-8 d-flex align-items-center gap-16 base-border-radius product cursor-pointer"
        [class.selected]="isPositionSelected(ticket.itemId, ticket.position)"
        (click)="togglePositionState(ticket, !isPositionSelected(ticket.itemId, ticket.position))"
      >
        <div class="d-flex align-items-center justify-content-space-between gap-16 flex-grow-1">
          <span class="p2">{{ 'Row'| trans:'cart/ticket/row.Label' }} <b>{{ ticket.seatRow }}</b> / {{ 'Seat'| trans:'cart/ticket/seat.Label' }} <b>{{ ticket.seatNr }}</b> – <b>{{ ticket.priceCategoryToken || ticket.priceCategory }}</b></span>
          <span class="p2">{{ ticket | cartItemDisplayTotal: cartStore.cart().discount: cartStore.cart().items | numberToCurrency }} {{ languageConfig.currency.short }}</span>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #cartItemProduct let-item="item">
  @for (_ of (item.quantity | arrayByLength); let index = $index; track index) {
    @let subIndex = index;
    <div
      class="p-8 d-flex align-items-center gap-16 base-border-radius product cursor-pointer"
      [class.selected]="isPositionSelected(item.itemId, item.position, subIndex)"
      (click)="togglePositionState(item, !isPositionSelected(item.itemId, item.position, subIndex), subIndex)"
    >
      <div class="d-flex align-items-center justify-content-space-between gap-16 flex-grow-1">
        <span class="p2">
          {{ item.name }}
          @if (item.itemType === cartItemTypes.Package && item.packageProducts?.length) {
            <span class="p3 c-t-gray-600">({{ getPackageProductsLabel(item) }})</span>
          }
          @if (item.quantity > 1) {
            <span class="p3 c-t-gray-600"> {{ index + 1 }}/{{ item.quantity }}</span>
          }
        </span>
        <span class="p2">{{ item.price | numberToCurrency }} {{ languageConfig.currency.short }}</span>
      </div>
    </div>
  }
</ng-template>

<ng-template #cartItemVoucher let-item="item">
  @if (item.quantity > 1) {
    @for (_ of (item.quantity | arrayByLength); let index = $index; track index) {
      @let subIndex = index;
      <div
        class="p-8 d-flex align-items-center gap-16 base-border-radius product cursor-pointer"
        [class.selected]="isPositionSelected(item.itemId, item.position, subIndex)"
        (click)="togglePositionState(item, !isPositionSelected(item.itemId, item.position, subIndex), subIndex)"
      >
        <div class="d-flex align-items-center justify-content-space-between gap-16 flex-grow-1">
          <span class="p2">
            {{ item.name }}
            <span class="p3 c-t-gray-600"> {{ index + 1 }}/{{ item.quantity }}</span>
          </span>
          <span class="p2">{{ item.price | numberToCurrency }} {{ languageConfig.currency.short }}</span>
        </div>
      </div>
    }
  } @else {
    <div
      class="p-8 d-flex align-items-center gap-16 base-border-radius product cursor-pointer"
      [class.selected]="isPositionSelected(item.itemId, item.position)"
      (click)="togglePositionState(item, !isPositionSelected(item.itemId, item.position))"
    >
      <div class="d-flex align-items-center justify-content-space-between gap-16 flex-grow-1">
        <span class="p2">{{ item.name }}</span>
        <span class="p2">{{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</span>
      </div>
    </div>
  }
</ng-template>

<ng-template #cartItemSimple let-item="item">
  <div
    class="p-8 d-flex align-items-center gap-16 base-border-radius product cursor-pointer"
    [class.selected]="isPositionSelected(item.itemId, item.position)"
    (click)="togglePositionState(item, !isPositionSelected(item.itemId, item.position))"
  >
    <div class="d-flex align-items-center justify-content-space-between gap-16 flex-grow-1">
      <span class="p2">{{ item.name }}</span>
      <span class="p2">{{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</span>
    </div>
  </div>
</ng-template>
